export const CHANGE_STATE_MENU = 'CHANGE_STATE_MENU';
export const RESET_MENU_STATUS = 'RESET_MENU_STATUS';
